import React, { useEffect, useState } from 'react';
import { makeandcheckerService } from '../../services';
import ClientsDrop from '../clients/makeandchecker/ClientsDrop';
import actionTypes from '../../constants/makeandchecker/actionsTypeId';
import actionStatuses from '../../constants/makeandchecker/statuses';

export default function Checker () {
    // State

    // Badge State

    const [clientsDropBadges, setClientsDropBadges] = useState(0);
    const [clientsDrop, setClientsDrop] = useState();

    // Functions

    const calculateBadges = (amount, from) => {
        if (from === 'clientsDrop') {
            setClientsDropBadges(amount);
        }
    };

    const fetchClientsDrop = () => {
        const options = {
            filters: `idType eq ${actionTypes.updateUserStatus},id_action_status eq ${actionStatuses.pending.id}`,
            pageSize: 100000
        };
        makeandcheckerService
            .getActions(options)
            .then(clients => {
                setClientsDropBadges(clients.length);
                setClientsDrop(clients);
            })
            .catch(e => console.error(e));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => fetchClientsDrop(), []);
    // Main Component

    return (
        <div className='pageContainerFluid'>
            <div>
                <ClientsDrop listDrop={clientsDrop} calculateBadges={calculateBadges} clientsDropBadges={clientsDropBadges}/>
            </div>
        </div>
    );
}
